import { FormattedMessage } from 'react-intl';
import { memo } from 'react';
import ProductPlaceholderWithoutText from './ProductPlaceholderWithoutText';
import ProductPlaceholderIndicator from './ProductPlaceholderIcon';

const ProductPlaceholder = ({ withoutText }: { withoutText?: boolean }) => {
    if (withoutText) return <ProductPlaceholderWithoutText />;

    return (
        <ProductPlaceholderIndicator>
            <FormattedMessage id="No picture available" />
        </ProductPlaceholderIndicator>
    );
};

export default memo(ProductPlaceholder);
